export const PAGE_SIZES = [25, 50, 100];
export const PAGINATION_DEFAULT_PAGE_SIZE = 25;
